/*
 * @Author: Tina Huang
 * @Date: 2024-03-11 11:03:56
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-08 15:41:19
 * @Description:
 */

import { Button, Result, Image } from 'antd'
import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
// import { Picks } from '@/constants/picks'

export default function GetTemplate() {
  const { code } = useParams()
  const navigate = useNavigate()
  const [result, setResult] = useState<any>('default')
  const [targetItem, setTargetItem] = useState<any>(null)
  const [myState, setMyState] = useState<any>(null)

  useEffect(() => {
    // 解析参数
    if (!code) return setResult('404')
    try {
      console.log(code)
      const state = JSON.parse(atob(decodeURIComponent(code)))
      console.log(state)
      setMyState(state)
      if (state?.time) {
        const expired_time = new Date(state.time)
        if (new Date() > expired_time) {
          return setResult('expired')
        }
      }
      if (state?.link) {
        state.checkItem && setTargetItem(state.checkItem)
        // window?.splitbee?.track('Vip Template from weapp', { id: state.id, linkId: state.link })
        return setResult('show')
      }
      throw new Error()
    } catch (err) {
      console.error(err)
      setResult('error')
    }
  }, [code])

  const handleDuplicate = () => {
    // window?.splitbee.track('Duplicate template from admin link', { id: myState.id, linkId: myState.link })
    window.open(
      `https://www.notion.so/${myState.link}?duplicate=true&pvs=36&utm_source=public_page&utm_content=duplicate_button&from=public_page&n=duplicate_public_page`
    )
  }

  const ReturnButton = (
    <Button type="primary" shape="round" onClick={() => navigate('/')}>
      返回首页
    </Button>
  )

  const resultProps: any = {
    '404': {
      status: '404',
      title: '404',
      subTitle: '没找到该模板，请确认模板链接正确',
      extra: ReturnButton,
    },
    error: {
      status: '500',
      title: '模板解析错误',
      subTitle: '模板解析错误，请确认模板链接正确',
      extra: ReturnButton,
    },
    expired: {
      status: '500',
      title: '模板链接已过期',
      subTitle: '模板链接已过期，请联系重新获取',
      extra: ReturnButton,
    },
  }

  let title = targetItem ? targetItem.title : myState?.title
  if (title?.indexOf('%') > -1) title = decodeURIComponent(title)

  return (
    <>
      {(result === '404' || result === 'error' || result === 'expired') && <Result {...resultProps[result]} />}
      {result === 'show' && (
        <div style={{ maxWidth: 450, margin: '0 auto' }}>
          <div className="text-center mb-8">
            <h1 className="text-xl font-bold">{title}</h1>
            <Image src={targetItem?.cover} className="my-4 rounded-md max-w-sm" />
            <Button type="primary" shape="round" block onClick={handleDuplicate}>
              拷贝到自己空间
            </Button>
          </div>
          <div className="leading-8">
            <h3 className="text-lg font-bold">模板拷贝方法：</h3>
            <p>
              第一步：在
              <a href="www.notion.so" className="font-bold text-blue-500">
                Notion官网
              </a>
              注册自己的Notion账号（若已注册请忽略）
            </p>
            <p>第二步：若未登录，请在当前浏览器登录自己的Notion账号</p>
            <p>
              第三步：点击上方的<strong>「拷贝到自己空间」</strong>按钮进行模板拷贝
            </p>
          </div>
        </div>
      )}
    </>
  )
}
